import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { KeyValuePipe } from "./key-value.pipe";
import { CustomDataColumn } from "../models/custom-viewer-config";
import { ColumnValue } from "../models/column-value";
import { PipeServiceImpl } from "pipe-service/pipe-service-impl";
import { TranslationService } from "@alfresco/adf-core";
import { ShareDataRow } from "@alfresco/adf-content-services";
import { hasAspect } from "../rules/alden.rules";
import { capitalize, isStringArray, parseStringToObject } from "../utils/string-utils";
import { AldenService } from "../services/alden.service";

@Pipe({ name: 'columnValue' })
export class ColumnValuePipe implements PipeTransform {

  constructor(private keyValuePipe: KeyValuePipe, private datePipe: DatePipe, private pipeService: PipeServiceImpl, private translationService: TranslationService, private aldenService: AldenService) { }

  transform(value: any, column: CustomDataColumn, elements?: string, context?: any, locale?: string): Promise<ColumnValue> {
    if (column.type === 'select') {
      value = this.keyValuePipe.transform(value, column.dataListName, elements);
    } else if (column.type === 'date') {
      value = this.datePipe.transform(value, column.format);
    } else if (column.type === 'month') {
      if (value !== undefined && value !== null && value !== "") {
        const month = Number(value);
        if (Number.isInteger(month) && month >= 1 && month <= 12) {
          const date = new Date(new Date().getFullYear(), month - 1, 1);
          locale ??= this.aldenService.locale;
          value = capitalize(this.datePipe.transform(date, column.format, null, locale));
        }
      }
    } else if (column.type === 'custom') {
      return this.pipeService.selectCustomPipe(column, value, elements);
    } else if (column.type === 'image') {
      return this.pipeService.selectCustomImagePipe(column, value, elements);
    } else if (column.type === 'boolean') {
      value = value === true
        ? this.translationService.instant('ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_TRUE_TEXT')
        : this.translationService.instant('ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_FALSE_TEXT');
    } else if (column.type === 'aspect') {
      const col: CustomDataColumn = context.col;
      const row: ShareDataRow = context.row;
      value = hasAspect(row.node, col.key.substring(col.key.indexOf('.') + 1, col.key.length))
        ? this.translationService.instant('ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_TRUE_TEXT')
        : this.translationService.instant('ALDEN.CUSTOM_LISTS.FILTERS.BOOLEAN_FALSE_TEXT');
    } else if (column.type === 'multiProp') {
      value = this.getMultiPropertyValue(value, column, elements);
    }

    const maxLength = 100;
    const valueString = this.getValue(value);
    const columnValue: ColumnValue = { value: valueString.substring(0, maxLength) + (valueString.length > maxLength ? '...' : ''), tooltip: Array.isArray(value) ? value.join(',\n') : valueString };
    return Promise.resolve(columnValue);
  }

  private getValue(value: any) {
    value = value ?? '';

    if (typeof value === 'string') {
      if (isStringArray(value)) {
        value = JSON.parse(value).join(", ")
      }
    } else {
      if (Array.isArray(value))
        value = value.join(", ")
      else
        value = value.toString();
    }

    return value;
  }

  private getMultiPropertyValue(value: string | string[], column: CustomDataColumn, elements?: string): string | string[] {
    const property: string = column.customData as string;
    if (Array.isArray(value)) {
      // Si es array, concatenamos los valores encontrados con coma
      const values = value.map(str => {
        const propertyValue = parseStringToObject(str)[property] ?? "";
        const dataListName = column.dataListName;
        return dataListName ? this.keyValuePipe.transform(propertyValue, dataListName, elements) : propertyValue;
      }).filter(v => v !== "");
      return values;
    } else {
      // Si es string único
      const propertyValue = parseStringToObject(value)[property] ?? "";
      const dataListName = column.dataListName;
      return dataListName ? this.keyValuePipe.transform(propertyValue, dataListName, elements) : propertyValue;
    }
  }

}